import curry from 'lodash/curry'
import CSSModules from 'react-css-modules'

export default curry((styles, component) => CSSModules(component, styles))
